import React from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import styled from "styled-components";
import { FaFileExcel } from "react-icons/fa";

const FileStatusesDetailExcelDownload = ({ data, fileStatusData }) => {
  if (!data) {
    return null;
  }

  const formatData = () => {
    const formattedData = data.map(
      ({
        // chequeNo,
        // companyName,
        // t24AccountNo,
        // t24AccountTitle,
        employeeName,
        employeeNo,
        titleFetchStatus,
        // nameStatus,
        employeeCnic,
        // cnicStatus,
        employeeAccountNo,
        accountNoStatus,
        amount,
        // segment,
        transactionCode,
        createdate,
        statusCode,
        statusDescr,
        // apiResponeCode,
        // companyAccountNo,
        // createuser,
        // fileDetailId,
        // lastupdatedate,
        // lastupdateuser,
        // updateindex,
        narration,
        batchId,
      }) => {
        return {
          // "Cheque No": chequeNo,
          // "Company Name": companyName,
          // "T24 Account No": t24AccountNo,
          // "T24 Account Title": t24AccountTitle,
          "Employee Name": employeeName,
          "Employee No": employeeNo,
          "Title Fetch Status": titleFetchStatus,
          // "Name Status": nameStatus,
          "Employee CNIC": employeeCnic,
          // "CNIC Status": cnicStatus,
          "Employee Account No": employeeAccountNo,
          "Account No Status": accountNoStatus,
          Amount: amount,
          // Segment: segment,
          "Transaction ID": transactionCode,
          "Create Date": createdate,
          "Status Code":
            statusCode === "I"
              ? "In Progress"
              : statusCode === "S"
                ? "Success"
                : statusCode === "E"
                  ? "Error"
                  : statusCode === "P"
                    ? "Processed"
                    : null,
          "Status Description": statusDescr,
          // "API Response Code": apiResponeCode,
          // "Company Account No": companyAccountNo,
          // "Create User": createuser,
          // "File Detail Id": fileDetailId,
          // "Last Update Date": lastupdatedate,
          // "Last Update User": lastupdateuser,
          // "Update Index": updateindex,
          Narration: narration,
          "Batch Id": fileStatusData?.batchId,
        };
      }
    );
    return formattedData;
  };

  const downloadExcel = () => {
    const formattedData = formatData();
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Zbiz File Statuses Detail"
    );
    const fileBuffer = XLSX.write(workbook, {
      type: "buffer",
      bookType: "xlsx",
    });
    saveAs(
      new Blob([fileBuffer], { type: "application/octet-stream" }),
      "Zbiz File Statuses Detail.xlsx"
    );
  };

  return (
    <div>
      <Button onClick={downloadExcel}>
        <FaFileExcel /> Download Excel
      </Button>
    </div>
  );
};

const Button = styled.button`
  background-color: #3ca2bb;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    margin-right: 0.5rem;
    transition: transform 0.3s ease-in-out;
  }

  &:hover {
    svg {
      transform: rotate3d(1, 1, 1, 45deg);
    }
  }
`;

export default FileStatusesDetailExcelDownload;
